import { Amplify } from "aws-amplify";
import { fromCognitoIdentityPool } from "@aws-sdk/credential-providers";
import { S3Client } from "@aws-sdk/client-s3";
import config from "../../amplifyconfiguration.json";

// Configure Amplify with your settings
Amplify.configure(config);

// AWS S3 Configuration from amplifyconfiguration.json
const s3Config = {
  bucketName: config.aws_user_files_s3_bucket,
  region: config.aws_user_files_s3_bucket_region,
};

// Create S3 Client using Cognito Identity Pool (no static keys needed!)
const s3Client = new S3Client({
  region: s3Config.region,
  credentials: fromCognitoIdentityPool({
    clientConfig: { region: config.aws_cognito_region },
    identityPoolId: config.aws_cognito_identity_pool_id,
  }),
});

export { s3Client, s3Config };
